import React from "react";
import { Badge, Box, LinkButton, Typography } from "@bca/ui-library";
import styled from "styled-components";
import getEnvironment from "../../getEnvironment";
import css from "@styled-system/css";

const Container = styled(Box)`
  ${css({
    borderBottom: "2px solid",
    borderColor: "primary-red",
  })}
`;

const PaymentFailed = () => {
  const environment = getEnvironment();
  const isProd = environment === "production";
  const href = isProd
    ? "https://www.bca.co.uk/buy/paying-with-bca"
    : "https://cms.uat.britishcarauctions.net/buy/paying-with-bca";
  return (
    <Container
      backgroundColor="rgba(254, 248, 248, 1);"
      paddingX={{
        mobile: "20px",
        desktop: "48px",
      }}
      paddingY="32px"
    >
      <Box paddingBottom="20px">
        <Badge label="Payment Failed" variant="negative" />
      </Box>
      <Box>
        <Typography variant="body-small">
          There seems to be an issue with your payment. Please contact your bank
          or building society provider. Alternatively, you can pay with one of
          our other{" "}
          <LinkButton
            href={href}
            color="text-color-hover"
            shouldOpenInNewWindow
            variant="tertiary"
            css="
            text-decoration: underline;"
            padding={0}
            height={4}
            fontWeight="bold"
            fontSize="body-small"
            data-en="click"
            data-ec="button"
            data-el="payment-methods"
            data-ea="navigate"
            data-es=""
          >
            payment methods
          </LinkButton>
        </Typography>
      </Box>
    </Container>
  );
};

export default PaymentFailed;
